export default {
  path: 'product-unit',
  component: () => import('@/views/settingSystem/setting-router.vue'),
  children: [
    {
      path: '',
      name: 'ProductUnitList',
      component: () => import('@/views/settingSystem/pages/product-unit/ProductUnitList.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'create',
      name: 'ProductUnitCreate',
      component: () => import('@/views/settingSystem/pages/product-unit/ProductUnitCreate.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'edit/:id',
      name: 'ProductUnitEdit',
      component: () => import('@/views/settingSystem/pages/product-unit/ProductUnitEdit.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    }
  ]
}
